import {
  LVTMetricCheckoutAnalysisStep,
  LVTMetricCheckoutAnalysisStepMap,
} from './types';

export const LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS = {
  stepName: 'stepName',
  startCheckoutTime: 'startCheckoutTime',
  closedWebsiteAt: 'closedWebsiteAt',
  sessionId: 'sessionId',
  entryStepName: 'entryStepName',
  basketId: 'basketId',
  paymentMethod: 'paymentMethod',
} as const;

const createCheckoutAnalysisSteps = (
  ...steps: LVTMetricCheckoutAnalysisStep[]
): LVTMetricCheckoutAnalysisStepMap =>
  steps.reduce<Record<string, string>>((acc, step) => {
    acc[step.toUpperCase()] = step.toLowerCase();
    return acc;
  }, {}) as LVTMetricCheckoutAnalysisStepMap;
export const LVT_METRIC_CHECKOUT_ANALYSIS_STEPS = createCheckoutAnalysisSteps(
  'schools_cpd_events_entry',
  'schools_cpd_events_add_to_basket',
  'checkout_completed',
  'checkout_abandoned'
);
